export function findNextUncompletedLevel(
  candidateLevels: number[],
  completedLevels: number[]
): number {
  if (candidateLevels.length === 0) return 0;

  const completedSet = new Set(completedLevels);
  const next = candidateLevels.find(level => !completedSet.has(level));
  return next ?? candidateLevels[0];
}

export function getLevelCardIndex(levels: number[], targetLevel: number): number {
  if (levels.length === 0) return -1;

  const index = levels.indexOf(targetLevel);
  return index >= 0 ? index : 0;
}
